module.exports = __webpack_public_path__ + "static/img/live_tu11.d291aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/live_tu11.png
// module id = u8uD
// module chunks = 1